// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
Swiper.use([ Navigation, Pagination ]);

window.addEventListener('DOMContentLoaded', (event) => {

    // Slider containers
    const swiperContainers = document.querySelectorAll('.ap-block-swiper');

	if ( swiperContainers ) {
		// Loop through each slider and set up Swiper basedon data attributes
		swiperContainers.forEach(slider => {

			// Settings stored in data attributes
			const slidesPerView     = parseInt( slider.getAttribute('data-setting-slidesPerView') );
			const initialSlide      = parseInt( slider.getAttribute('data-setting-initialSlide') );
			const spaceBetween      = parseInt( slider.getAttribute('data-setting-spaceBetween') );
			const slidesPerGroup    = parseInt( slider.getAttribute('data-setting-slidesPerGroup') );	
			const centeredSlides    = ( slider.getAttribute('data-setting-centeredSlides') === 'true');
			const loop              = ( slider.getAttribute('data-setting-loop') === 'true');
			const autoHeight        = ( slider.getAttribute('data-setting-autoHeight') === 'true');
			const enableNavigation  = ( slider.getAttribute('data-setting-enableNavigation') === 'true');
			const enableScrollbar  = ( slider.getAttribute('data-setting-enableScrollbar') === 'true');
			const preventClicks  = ( slider.getAttribute('data-setting-preventClicks') === 'true');


			const swiperSettings = {
				slidesPerView: 1,
				centeredSlides: false,
				initialSlide: initialSlide,
				loop: loop,
				spaceBetween: 0,
				autoHeight: autoHeight,
				slidesPerGroup: 1,
				preventClicks: preventClicks,
				modules: [Navigation, Pagination],
				// Pagination always on mobile
				pagination: {
					el: ".swiper-pagination",
					dynamicBullets: true,
					enabled: true,
					clickable: true,
				},
				// Navigation never on mobile
				navigation: false,
				breakpoints: {
					// when window width is >= 640px
					640: {
						slidesPerView: slidesPerView,
						slidesPerGroup: slidesPerGroup,
						spaceBetween: spaceBetween,
						centeredSlides: centeredSlides,
						// Navigation sometimes on desktop
						...(enableNavigation && {
							navigation: {
								disabledClass: 'swiper-disabled',
								nextEl: '.' + slider.id + '-button-next',
								prevEl: '.' + slider.id + '-button-prev',
							}
						}),
						// Pagination never on desktop
						pagination: false,
					},
				},
			}

			const swiper = new Swiper('#'+slider.id, swiperSettings);
			

		});
	}
});
